const INITIAL_STATE = {
  editProductDialog: {
    show: false,
    activeTab: 0,
    data: {},
  },
  helpDialog: {
    show: false,
    data: {},
  },
};

export default function menu(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_FIELD_DIALOG":
      return {
        ...state,
        [action.dialogName]: {
          ...state[action.dialogName],
          [action.field]: action.value,
        },
      };
    default:
      return state;
  }
}
